// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_2sK61q"};